module.exports = __webpack_public_path__ + "static/media/双足机器人1-PNG.e13920ce.png";